import styled from 'styled-components';

import { style } from '@genially/design-system';

interface ReactionsWrapperProps {
  $visible: boolean;
}

export const ReactionsWrapper = styled.div<ReactionsWrapperProps>(
  ({ theme: { size, transition }, $visible }) => ({
    opacity: $visible ? 1 : 0,
    transform: $visible ? 'translateY(0)' : `translateY(${size.units(1.5)})`,
    // Larger than actual content — collapses to 0 on hide so the sibling centers smoothly
    maxWidth: $visible ? size.units(60) : 0,
    overflow: 'hidden',
    flexShrink: 1,
    minWidth: 0,
    transition: transition.standard('opacity', 'transform', 'max-width'),
  }),
);

interface RaiseHandWrapperProps {
  $visible: boolean;
}

export const RaiseHandWrapper = styled.div<RaiseHandWrapperProps>(
  ({ theme: { size, transition }, $visible }) => ({
    opacity: $visible ? 1 : 0,
    transform: $visible ? 'translateY(0)' : `translateY(${size.units(1.5)})`,
    // Larger than actual content — collapses to 0 on hide so the sibling centers smoothly
    maxWidth: $visible ? size.units(50) : 0,
    flexShrink: 0,
    transition: transition.standard('opacity', 'transform', 'max-width'),
  }),
);

interface WrapperProps {
  $visible: boolean;
  $isMobile: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { size, transition }, $visible, $isMobile }) => ({
    position: 'fixed',
    bottom: $isMobile ? size.units(7) : size.units(3),
    left: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    pointerEvents: $visible || $isMobile ? 'auto' : 'none',
    zIndex: 20,
    ...($isMobile
      ? {
          opacity: 1,
          transform: $visible
            ? 'translateX(-50%) translateY(0)'
            : `translateX(-50%) translateY(calc(100% + ${size.units(4)}))`,
          transition: transition.standard('transform'),
        }
      : {
          opacity: $visible ? 1 : 0,
          transform: $visible
            ? 'translateX(-50%) translateY(0)'
            : `translateX(-50%) translateY(${size.units(2)})`,
          transition: transition.standard('opacity', 'transform'),
        }),

    ...style.mixins.responsive.sm.downward({
      maxWidth: `calc(100% - ${size.units(2)})`,
    }),
  }),
);

export const ContentWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  gap: size.units(1.5),
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));
